import { BehaviorSubject, Subject, of, combineLatest, merge, NEVER, isObservable, Subscription } from 'rxjs';
import { map, takeUntil, catchError, tap, switchMap, startWith, shareReplay, distinctUntilChanged, debounceTime, filter, take, skip } from 'rxjs/operators';
import * as i0 from '@angular/core';
import { Injectable, Directive, EventEmitter, signal, computed, TemplateRef, booleanAttribute, Input, Output, ViewChild, ContentChild, HostBinding, Optional, Self, ChangeDetectionStrategy, ViewEncapsulation, Component, NgModule } from '@angular/core';
import { NgTemplateOutlet, CommonModule } from '@angular/common';
import * as i3 from '@angular/forms';
import { FormControl, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatIconButton } from '@angular/material/button';
import * as i1 from '@angular/material/core';
import { _ErrorStateTracker, MatOption } from '@angular/material/core';
import { MatFormFieldControl } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatSelect, MatSelectTrigger, MatSelectModule } from '@angular/material/select';
import { MatTooltip, MatTooltipModule } from '@angular/material/tooltip';
import { ZvErrorMessagePipe } from '@zvoove/components/core';
import * as i4 from 'ngx-mat-select-search';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
const _c0 = a0 => ({
  $implicit: a0
});
function ZvSelect_Conditional_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 9);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.triggerTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c0, ctx_r0.$customTriggerData()));
  }
}
function ZvSelect_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-select-trigger");
    i0.ɵɵtemplate(1, ZvSelect_Conditional_2_Conditional_1_Template, 1, 4, "ng-container", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.triggerTemplate ? 1 : -1);
  }
}
function ZvSelect_Conditional_3_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.$selectedItemsTriggerLabel(), " ");
  }
}
function ZvSelect_Conditional_3_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 9);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.triggerTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c0, ctx_r0.$customTriggerData()));
  }
}
function ZvSelect_Conditional_3_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵi18n(1, 0);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵi18nExp(ctx_r0.$customTriggerDataArray().length);
    i0.ɵɵi18nApply(1);
  }
}
function ZvSelect_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-select-trigger", 3)(1, "div", 10);
    i0.ɵɵtemplate(2, ZvSelect_Conditional_3_Conditional_2_Template, 1, 1)(3, ZvSelect_Conditional_3_Conditional_3_Template, 1, 4, "ng-container", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, ZvSelect_Conditional_3_Conditional_4_Template, 2, 1, "div", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(!ctx_r0.triggerTemplate ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.triggerTemplate ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.$customTriggerDataArray().length > 1 && ctx_r0.selectedLabel ? 4 : -1);
  }
}
function ZvSelect_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6)(1, "mat-option", 12)(2, "span", 13);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "zvErrorMessage");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "button", 14);
    i0.ɵɵlistener("click", function ZvSelect_Conditional_6_Template_button_click_5_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.reloadAfterError());
    });
    i0.ɵɵelementStart(6, "mat-icon");
    i0.ɵɵtext(7, "refresh");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", true);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 2, ctx_r0.error));
  }
}
function ZvSelect_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 7);
    i0.ɵɵtext(1, " -- ");
    i0.ɵɵelementEnd();
  }
}
function ZvSelect_For_9_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const item_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵtextInterpolate1(" ", item_r3.label, " ");
  }
}
function ZvSelect_For_9_Conditional_2_ng_template_0_Template(rf, ctx) {}
function ZvSelect_For_9_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ZvSelect_For_9_Conditional_2_ng_template_0_Template, 0, 0, "ng-template", 9);
  }
  if (rf & 2) {
    const item_r3 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.optionTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c0, item_r3));
  }
}
function ZvSelect_For_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 15);
    i0.ɵɵtemplate(1, ZvSelect_For_9_Conditional_1_Template, 1, 1)(2, ZvSelect_For_9_Conditional_2_Template, 1, 4, null, 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r3 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("zv-select__option--hidden", item_r3.hidden);
    i0.ɵɵproperty("value", item_r3.value)("disabled", item_r3.disabled);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r0.optionTemplate ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.optionTemplate ? 2 : -1);
  }
}
const DEFAULT_COMPARER = (a, b) => a === b;
class ZvSelectDataSource {
  /** The flag that indicates if the select is currently loading data. */
  loading = false;
  /** The error that occured in the last observable returned by _loadItems or null. */
  error = null;
  compareWith = DEFAULT_COMPARER;
}
/** Checks whether an object is a data source. */
function isZvSelectDataSource(value) {
  // Check if the value is a ZvSelectDataSource by observing if it has a connect function. Cannot
  // be checked as an `instanceof ZvSelectDataSource` since people could create their own sources
  // that match the interface, but don't extend ZvSelectDataSource.
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-member-access
  return value && typeof value.connect === 'function';
}

/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-redundant-type-constituents */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-return */
function isZvSelectOptionsData(value) {
  return typeof value === 'object' && 'idKey' in value && 'labelKey' in value && 'items' in value && 'mode' in value;
}
/**
 * At which point(s) to load the select data. Defaults to {@link ZvSelectLoadTrigger.initial}.
 */
var ZvSelectLoadTrigger = /*#__PURE__*/function (ZvSelectLoadTrigger) {
  /**
   * Load values of select only once, on initial rendering of zv-select.
   */
  ZvSelectLoadTrigger[ZvSelectLoadTrigger["initial"] = 1] = "initial";
  /**
   * Load values of select only once, when the user first clicks on it.
   */
  ZvSelectLoadTrigger[ZvSelectLoadTrigger["firstPanelOpen"] = 2] = "firstPanelOpen";
  /**
   * Load values of select every time when the user first clicks on it.
   */
  ZvSelectLoadTrigger[ZvSelectLoadTrigger["everyPanelOpen"] = 4] = "everyPanelOpen";
  /**
   * Load values on all of the above conditions.
   */
  ZvSelectLoadTrigger[ZvSelectLoadTrigger["all"] = 7] = "all";
  return ZvSelectLoadTrigger;
}(ZvSelectLoadTrigger || {});
var ZvSelectSortBy = /*#__PURE__*/function (ZvSelectSortBy) {
  ZvSelectSortBy[ZvSelectSortBy["none"] = 0] = "none";
  ZvSelectSortBy[ZvSelectSortBy["selected"] = 1] = "selected";
  ZvSelectSortBy[ZvSelectSortBy["comparer"] = 2] = "comparer";
  ZvSelectSortBy[ZvSelectSortBy["both"] = 3] = "both";
  return ZvSelectSortBy;
}(ZvSelectSortBy || {});
class DefaultZvSelectDataSource extends ZvSelectDataSource {
  _searchDebounceTime;
  _loadTrigger;
  _sortBy;
  _isPanelOpen$ = new BehaviorSubject(false);
  _forceReload$ = new Subject();
  _searchText$ = new BehaviorSubject('');
  _currentValues$ = new BehaviorSubject([]);
  _ngUnsubscribe$ = new Subject();
  _loadData;
  constructor(options) {
    super();
    this._searchDebounceTime = options.searchDebounce ?? 300;
    this._loadTrigger = options.loadTrigger ?? ZvSelectLoadTrigger.initial;
    this._sortBy = options.sortBy ?? ZvSelectSortBy.both;
    let loadData;
    const entityToSelectItem = createEntityToSelectItemMapper(options.mode, options.idKey, options.labelKey, options.disabledKey);
    const items = options.items;
    if (typeof items !== 'function') {
      const data$ = ensureObservable(items).pipe(map(x => x.map(entityToSelectItem)), takeUntil(this._ngUnsubscribe$));
      loadData = () => data$;
    } else {
      const func = items;
      loadData = () => ensureObservable(func()).pipe(map(x => x.map(entityToSelectItem)));
    }
    if (options.mode === 'entity') {
      this.compareWith = createEntityComparer(options.idKey);
      this.getItemsForValues = values => values.map(entityToSelectItem);
    }
    this._loadData = () => {
      this.loading = true;
      this.error = null;
      return loadData().pipe(catchError(err => {
        this.error = err;
        return of([]);
      }), tap(() => {
        this.loading = false;
      }));
    };
  }
  connect() {
    const optionsLoadTrigger$ = this._createOptionsLoadTrigger();
    const loadedOptions$ = optionsLoadTrigger$.pipe(switchMap(() => this._loadData()), startWith([]), map(options => options.map(normalizeLabel)), shareReplay({
      bufferSize: 1,
      refCount: true
    }));
    // generate values as options, that aren't in the loaded options
    const missingOptions$ = loadedOptions$.pipe(switchMap(options => this._currentValues$.pipe(map(values => values.filter(value => !options.find(o => this.compareWith(o.value, value)))))), distinctUntilChanged((a, b) => {
      if (a.length !== b.length) {
        return false;
      }
      for (const value of a) {
        if (!b.find(o => this.compareWith(o, value))) {
          return false;
        }
      }
      return true;
    }), map(missingValues => this.getItemsForValues(missingValues).map(normalizeLabel)));
    let renderOptions$ = combineLatest([loadedOptions$, missingOptions$]).pipe(debounceTime(0), map(([options, missingOptions]) => missingOptions.concat(options)));
    if (this._sortBy) {
      const sortTrigger$ = this._createSortTrigger();
      renderOptions$ = renderOptions$.pipe(switchMap(unsortedOptions => sortTrigger$.pipe(map(() => this._cloneAndSort(unsortedOptions)))));
    }
    // searchtext handling
    renderOptions$ = renderOptions$.pipe(switchMap(options => this._searchText$.pipe(debounceTime(this._searchDebounceTime), startWith(this._searchText$.value), map(x => (x || '').toLowerCase()), distinctUntilChanged(), map(searchText => {
      options.forEach(option => {
        option.hidden = this.searchCompare(option, searchText);
      });
      return options;
    }))));
    return renderOptions$;
  }
  disconnect() {
    this._isPanelOpen$.complete();
    this._forceReload$.complete();
    this._searchText$.complete();
    this._currentValues$.complete();
    this._ngUnsubscribe$.next();
    this._ngUnsubscribe$.complete();
  }
  panelOpenChanged(panelOpen) {
    this._isPanelOpen$.next(panelOpen);
  }
  searchTextChanged(searchText) {
    this._searchText$.next(searchText);
  }
  selectedValuesChanged(values) {
    this._currentValues$.next(values);
  }
  forceReload() {
    this._forceReload$.next(null);
  }
  getItemsForValues(values) {
    return values.map(v => ({
      value: v,
      label: `??? (ID: ${v})`
    }));
  }
  /**
   * Sort comparer for the items.
   * Note: Selected items will still be at the top.
   */
  sortCompare = (a, b) => a.label.localeCompare(b.label);
  /**
   * Search comparer for the items.
   */
  searchCompare = (option, searchText) => option.label.toLowerCase().indexOf(searchText) === -1;
  _createOptionsLoadTrigger() {
    const loadTriggers = [this._forceReload$];
    if (this._loadTrigger & ZvSelectLoadTrigger.initial) {
      loadTriggers.push(of(null));
    }
    const panelOpen$ = this._isPanelOpen$.pipe(distinctUntilChanged(), filter(panelOpen => panelOpen));
    if (this._loadTrigger & ZvSelectLoadTrigger.everyPanelOpen) {
      loadTriggers.push(panelOpen$);
    } else if (this._loadTrigger & ZvSelectLoadTrigger.firstPanelOpen) {
      loadTriggers.push(panelOpen$.pipe(take(1)));
    }
    return merge(...loadTriggers);
  }
  _createSortTrigger() {
    const panelCloseEvent$ = this._isPanelOpen$.pipe(skip(1),
    // we don't need the initial value
    distinctUntilChanged(), filter(x => !x) // we only care about close-events
    );
    const valueChangedWhileClosed$ = this._isPanelOpen$.pipe(distinctUntilChanged(), switchMap(panelOpen => panelOpen ? NEVER : this._currentValues$.pipe(skip(1))));
    // initially and on panel close we must sort the selected options to the top
    return merge(panelCloseEvent$, valueChangedWhileClosed$).pipe(startWith(0));
  }
  _cloneAndSort(unsortedOptions) {
    let selectedOptionsSet = null;
    if (this._sortBy & ZvSelectSortBy.selected) {
      const selectedOptions = unsortedOptions.filter(option => this._currentValues$.value.find(value => this.compareWith(option.value, value)));
      selectedOptionsSet = new WeakSet(selectedOptions);
    }
    const sortedOptions = unsortedOptions.slice().sort((a, b) => {
      if (this._sortBy & ZvSelectSortBy.selected) {
        const aSelected = +selectedOptionsSet.has(a);
        const bSelected = +selectedOptionsSet.has(b);
        const selectedDifferent = bSelected - aSelected;
        if (selectedDifferent) {
          return selectedDifferent;
        }
      }
      return this._sortBy & ZvSelectSortBy.comparer ? this.sortCompare(a, b) : 0;
    });
    return sortedOptions;
  }
}
function ensureObservable(data) {
  if (!isObservable(data)) {
    data = of(data);
  }
  return data;
}
function createEntityToSelectItemMapper(mode, idKey, labelKey, disabledKey) {
  if (mode === 'id') {
    return item => ({
      value: item[idKey],
      label: item[labelKey],
      entity: item,
      disabled: disabledKey && item[disabledKey] || false
    });
  }
  return item => ({
    value: item,
    label: item[labelKey],
    entity: item,
    disabled: disabledKey && item[disabledKey] || false
  });
}
function createEntityComparer(idKey) {
  return (entity1, entity2) => {
    // Wenn sie gleich sind, sind sie wohl gleich :D
    if (entity1 === entity2) {
      return true;
    }
    // Wenn der typ ungleich ist, dann sind sie nicht gleich
    if (typeof entity1 !== typeof entity2) {
      return false;
    }
    // Wenn eins von beidem falsy ist, es aber nicht das gleiche falsy ist (check oben), dann sind sie nicht gleich
    if (!entity1 || !entity2) {
      return false;
    }
    // Wenn es kein Object ist, wird es nicht unterstützt und wir geben false zurück
    if (typeof entity1 !== 'object') {
      return false;
    }
    return entity1[idKey] === entity2[idKey];
  };
}
function normalizeLabel(option) {
  if (!option.label) {
    option.label = '';
  } else if (!(typeof option.label === 'string')) {
    option.label = `${option.label}`;
  }
  return option;
}

/**
 * Returns an error that should be thrown when the data source does not match the compatible types.
 *
 * @docs-private
 */
function getSelectUnknownDataSourceError() {
  return Error('The provided data source did not match any of the compatible types');
}
let ZvSelectService = /*#__PURE__*/(() => {
  class ZvSelectService {
    static ɵfac = function ZvSelectService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ZvSelectService)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ZvSelectService,
      factory: ZvSelectService.ɵfac,
      providedIn: 'root'
    });
  }
  return ZvSelectService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DefaultZvSelectService = /*#__PURE__*/(() => {
  class DefaultZvSelectService extends ZvSelectService {
    createDataSource(dataSource, _) {
      if (isZvSelectDataSource(dataSource)) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return dataSource;
      }
      let options;
      if (Array.isArray(dataSource) || isObservable(dataSource)) {
        options = {
          mode: 'id',
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          labelKey: 'label',
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          idKey: 'value',
          items: dataSource
        };
      } else if (isZvSelectOptionsData(dataSource)) {
        options = dataSource;
      } else {
        throw getSelectUnknownDataSourceError();
      }
      return new DefaultZvSelectDataSource(options);
    }
    static ɵfac = /* @__PURE__ */(() => {
      let ɵDefaultZvSelectService_BaseFactory;
      return function DefaultZvSelectService_Factory(__ngFactoryType__) {
        return (ɵDefaultZvSelectService_BaseFactory || (ɵDefaultZvSelectService_BaseFactory = i0.ɵɵgetInheritedFactory(DefaultZvSelectService)))(__ngFactoryType__ || DefaultZvSelectService);
      };
    })();
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: DefaultZvSelectService,
      factory: DefaultZvSelectService.ɵfac,
      providedIn: 'root'
    });
  }
  return DefaultZvSelectService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ZvSelectOptionTemplate = /*#__PURE__*/(() => {
  class ZvSelectOptionTemplate {
    templateRef;
    constructor(templateRef) {
      this.templateRef = templateRef;
    }
    static ɵfac = function ZvSelectOptionTemplate_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ZvSelectOptionTemplate)(i0.ɵɵdirectiveInject(i0.TemplateRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ZvSelectOptionTemplate,
      selectors: [["", "zvSelectOptionTemplate", ""]]
    });
  }
  return ZvSelectOptionTemplate;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ZvSelectTriggerTemplate = /*#__PURE__*/(() => {
  class ZvSelectTriggerTemplate {
    templateRef;
    constructor(templateRef) {
      this.templateRef = templateRef;
    }
    static ɵfac = function ZvSelectTriggerTemplate_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ZvSelectTriggerTemplate)(i0.ɵɵdirectiveInject(i0.TemplateRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ZvSelectTriggerTemplate,
      selectors: [["", "zvSelectTriggerTemplate", ""]]
    });
  }
  return ZvSelectTriggerTemplate;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var ValueChangeSource = /*#__PURE__*/function (ValueChangeSource) {
  ValueChangeSource[ValueChangeSource["matSelect"] = 1] = "matSelect";
  ValueChangeSource[ValueChangeSource["toggleAll"] = 2] = "toggleAll";
  ValueChangeSource[ValueChangeSource["valueInput"] = 3] = "valueInput";
  ValueChangeSource[ValueChangeSource["writeValue"] = 4] = "writeValue";
  return ValueChangeSource;
}(ValueChangeSource || {});
let ZvSelect = /*#__PURE__*/(() => {
  class ZvSelect {
    cd;
    selectService;
    ngControl;
    static nextId = 0;
    id = `zv-select-${ZvSelect.nextId++}`;
    optionTemplate = null;
    customTrigger = null;
    get triggerTemplate() {
      return this.customTrigger?.templateRef ?? null;
    }
    set setMatSelect(select) {
      this._matSelect = select;
      // MatSelect doesn't trigger stateChanges on close which causes problems, so we patch it here.
      // eslint-disable-next-line @typescript-eslint/unbound-method
      const close = select.close;
      select.close = () => {
        close.call(select);
        select.stateChanges.next();
      };
    }
    /**
     * Stream containing the latest information on what rows are being displayed on screen.
     * Can be used by the data source to as a heuristic of what data should be provided.
     */
    viewChange = new BehaviorSubject({
      start: 0,
      end: Number.MAX_VALUE
    });
    /**
     * The selects's source of data, which can be provided in three ways (in order of complexity):
     *   - Simple data array (each object represents one select option)
     *   - Stream that emits a data array each time the array changes
     *   - `DataSource` object that implements the connect/disconnect interface.
     */
    get dataSource() {
      return this._dataSourceInstance;
    }
    set dataSource(dataSource) {
      if (this._dataSourceInput !== dataSource) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        this._dataSourceInput = dataSource;
        this._switchDataSource(dataSource);
      }
    }
    get value() {
      return this._value;
    }
    set value(value) {
      this._propagateValueChange(value, ValueChangeSource.valueInput);
    }
    _value = null;
    /** If true, then there will be a empty option available to deselect any values (only single select mode) */
    clearable = true;
    /** If true, then there will be a toggle all checkbox available (only multiple select mode) */
    showToggleAll = true;
    multiple = false;
    panelClass = '';
    placeholder = '';
    required = false;
    selectedLabel = true;
    /**
     * Event that emits whenever the raw value of the select changes. This is here primarily
     * to facilitate the two-way binding for the `value` input.
     *
     * @docs-private
     */
    valueChange = new EventEmitter();
    openedChange = new EventEmitter();
    selectionChange = new EventEmitter();
    empty = true;
    get shouldLabelFloat() {
      return !this.empty;
    }
    get focused() {
      const matFocus = this._matSelect.focused;
      if (matFocus != null) {
        return this._focused || matFocus;
      }
      return this._focused;
    }
    disabled = false;
    /**
     * Implemented as part of MatFormFieldControl.
     *
     * @docs-private
     */
    stateChanges = new Subject();
    get errorStateMatcher() {
      return this._errorStateTracker.matcher;
    }
    set errorStateMatcher(value) {
      this._errorStateTracker.matcher = value;
    }
    /** Whether the input is in an error state. */
    get errorState() {
      return this._errorStateTracker.errorState;
    }
    set errorState(value) {
      this._errorStateTracker.errorState = value;
    }
    get compareWith() {
      return this._dataSourceInstance?.compareWith ?? DEFAULT_COMPARER;
    }
    controlType = 'zv-select';
    /** FormControl for the search filter */
    filterCtrl = new FormControl('', {
      nonNullable: true
    });
    /** The items to display */
    items = [];
    toggleAllCheckboxChecked = false;
    toggleAllCheckboxIndeterminate = false;
    /** true while the options are loading */
    get loading() {
      return !!this._dataSourceInstance?.loading;
    }
    /** true when there was an error while loading the options */
    get hasError() {
      return !!this.error;
    }
    /** the error that occured while loading the options */
    get error() {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      return this._dataSourceInstance?.error;
    }
    /** If true, then the empty option should be shown. */
    get showEmptyInput() {
      if (this.multiple || !this.clearable || !this.items?.length) {
        return false;
      }
      const searchText = (this.filterCtrl.value || '').toLowerCase();
      return !searchText || '--'.indexOf(searchText) > -1;
    }
    get tooltip() {
      // MatSelect is not fully initialized in the beginning, so we need to skip this here until it is ready
      if (this.multiple && this._matSelect?._selectionModel && this._matSelect.selected) {
        return this._matSelect.selected.map(x => x.viewValue).join(', ');
      }
      return '';
    }
    $currentSelection = signal([]);
    $customTriggerDataArray = computed(() => {
      const selectedOptions = this.$currentSelection().map(option => {
        return {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          value: option.value,
          viewValue: option.viewValue
        };
      });
      return this._matSelect._isRtl() ? selectedOptions.reverse() : selectedOptions;
    });
    /** The value displayed in the trigger. */
    $customTriggerData = computed(() => {
      if (this.multiple) {
        return this.$customTriggerDataArray();
      }
      return this.$customTriggerDataArray()[0];
    });
    $selectedItemsTriggerLabel = computed(() => {
      if (this.empty) return '';
      return this.$customTriggerDataArray().map(x => x.viewValue).join(', ');
    });
    /** Subject that emits when the component has been destroyed. */
    _ngUnsubscribe$ = new Subject();
    /** Subscription that listens for the data provided by the data source. */
    _renderChangeSubscription = Subscription.EMPTY;
    /** The data source. */
    _dataSourceInstance;
    /** The value the [dataSource] input was called with. */
    _dataSourceInput;
    _matSelect;
    _onModelTouched;
    _focused = false;
    _onInitCalled = false;
    _errorStateTracker;
    /** View -> model callback called when value changes */
    _onChange = () => {};
    constructor(defaultErrorStateMatcher, cd, selectService, parentForm, parentFormGroup, ngControl) {
      this.cd = cd;
      this.selectService = selectService;
      this.ngControl = ngControl;
      if (this.ngControl) {
        // Note: we provide the value accessor through here, instead of
        // the `providers` to avoid running into a circular import.
        this.ngControl.valueAccessor = this;
      }
      this._errorStateTracker = new _ErrorStateTracker(defaultErrorStateMatcher, ngControl, parentFormGroup, parentForm, this.stateChanges);
    }
    ngDoCheck() {
      if (this.ngControl) {
        this.updateErrorState();
      }
    }
    /** Refreshes the error state of the input. */
    updateErrorState() {
      this._errorStateTracker.updateErrorState();
    }
    ngOnInit() {
      this._onInitCalled = true;
      // before oninit ngControl.control isn't set, but it is needed for datasource creation
      this._switchDataSource(this._dataSourceInput);
      this.filterCtrl.valueChanges.pipe(takeUntil(this._ngUnsubscribe$))
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
      .subscribe(searchText => this.dataSource.searchTextChanged(searchText));
      let selectionSignalInitialized = false;
      this._matSelect.stateChanges.pipe(tap(() => {
        if (!selectionSignalInitialized && this._matSelect._selectionModel) {
          this.$currentSelection.set(this._matSelect._selectionModel.selected);
          this._matSelect._selectionModel.changed.pipe(takeUntil(this._ngUnsubscribe$)).subscribe(() => {
            this.$currentSelection.set(this._matSelect._selectionModel.selected);
          });
          selectionSignalInitialized = true;
        }
      }), takeUntil(this._ngUnsubscribe$)).subscribe(this.stateChanges);
    }
    ngOnDestroy() {
      this._ngUnsubscribe$.next();
      this._ngUnsubscribe$.complete();
      this.viewChange.complete();
      this._renderChangeSubscription.unsubscribe();
    }
    onContainerClick(_) {
      this._matSelect.onContainerClick();
    }
    setDescribedByIds(ids) {
      this._matSelect.setDescribedByIds(ids);
    }
    writeValue(value) {
      this._propagateValueChange(value, ValueChangeSource.writeValue);
    }
    registerOnChange(fn) {
      this._onChange = fn;
    }
    registerOnTouched(fn) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      this._onModelTouched = fn;
    }
    setDisabledState(isDisabled) {
      this.disabled = isDisabled;
    }
    onSelectionChange(event) {
      this._updateToggleAllCheckbox();
      this.selectionChange.emit(event);
    }
    onOpenedChange(open) {
      this._onFocusChanged(open);
      this.openedChange.emit(open);
      this._dataSourceInstance.panelOpenChanged(open);
    }
    onValueChange(value) {
      this._propagateValueChange(value, ValueChangeSource.matSelect);
    }
    onToggleAll(state) {
      const newValue = state ? this.items.map(x => x.value) : [];
      this._propagateValueChange(newValue, ValueChangeSource.toggleAll);
    }
    trackByOptions(_, item) {
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      return `${item.value}#${item.label}`;
    }
    reloadAfterError() {
      this._dataSourceInstance.forceReload();
    }
    _propagateValueChange(value, source) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      this._value = value;
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      this.empty = this.multiple ? !value?.length : value == null || value === '';
      this._updateToggleAllCheckbox();
      this._pushSelectedValuesToDataSource(value);
      if (source !== ValueChangeSource.valueInput) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        this.valueChange.emit(value);
      }
      if (source !== ValueChangeSource.writeValue) {
        this._onChange(value);
      }
      this.cd.markForCheck();
    }
    _pushSelectedValuesToDataSource(value) {
      if (!this._dataSourceInstance) {
        return;
      }
      let values;
      if (this.multiple) {
        values = Array.isArray(value) ? value : [];
      } else {
        values = value ? [value] : [];
      }
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      this._dataSourceInstance.selectedValuesChanged(values);
    }
    /** Set up a subscription for the data provided by the data source. */
    _switchDataSource(dataSource) {
      if (!this._onInitCalled) {
        // before oninit ngControl.control isn't set, but it is needed for datasource creation
        return;
      }
      // Stop listening for data from the previous data source.
      this._dataSourceInstance?.disconnect();
      this._renderChangeSubscription.unsubscribe();
      this._dataSourceInstance = this.selectService?.createDataSource(dataSource, this.ngControl?.control) ?? dataSource;
      if (!isZvSelectDataSource(this._dataSourceInstance)) {
        throw getSelectUnknownDataSourceError();
      }
      this._dataSourceInstance.searchTextChanged(this.filterCtrl.value);
      this._dataSourceInstance.panelOpenChanged(this._matSelect.panelOpen);
      this._pushSelectedValuesToDataSource(this._value);
      this._renderChangeSubscription = this._dataSourceInstance.connect().subscribe(items => {
        this.items = items || [];
        this._updateToggleAllCheckbox();
        this.cd.markForCheck();
      });
    }
    _updateToggleAllCheckbox() {
      if (this.multiple && this.items && Array.isArray(this._value)) {
        const selectedValueCount = this._value.length;
        this.toggleAllCheckboxChecked = this.items.length === selectedValueCount;
        this.toggleAllCheckboxIndeterminate = selectedValueCount > 0 && selectedValueCount < this.items.length;
      }
    }
    /** Callback for the cases where the focused state of the input changes. */
    _onFocusChanged(isFocused) {
      if (isFocused !== this.focused) {
        this._focused = isFocused;
        this.stateChanges.next();
      }
      if (!isFocused && this._onModelTouched != null) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        this._onModelTouched();
      }
    }
    static ɵfac = function ZvSelect_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ZvSelect)(i0.ɵɵdirectiveInject(i1.ErrorStateMatcher), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(ZvSelectService, 8), i0.ɵɵdirectiveInject(i3.NgForm, 8), i0.ɵɵdirectiveInject(i3.FormGroupDirective, 8), i0.ɵɵdirectiveInject(i3.NgControl, 10));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ZvSelect,
      selectors: [["zv-select"]],
      contentQueries: function ZvSelect_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, ZvSelectOptionTemplate, 5, TemplateRef);
          i0.ɵɵcontentQuery(dirIndex, ZvSelectTriggerTemplate, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.optionTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.customTrigger = _t.first);
        }
      },
      viewQuery: function ZvSelect_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(MatSelect, 7);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.setMatSelect = _t.first);
        }
      },
      hostAttrs: [1, "zv-select"],
      hostVars: 11,
      hostBindings: function ZvSelect_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵhostProperty("id", ctx.id);
          i0.ɵɵclassProp("zv-select-multiple", ctx.multiple)("zv-select-disabled", ctx.disabled)("zv-select-invalid", ctx.errorState)("zv-select-required", ctx.required)("zv-select-empty", ctx.empty);
        }
      },
      inputs: {
        dataSource: "dataSource",
        value: "value",
        clearable: "clearable",
        showToggleAll: "showToggleAll",
        multiple: "multiple",
        panelClass: "panelClass",
        placeholder: "placeholder",
        required: "required",
        selectedLabel: "selectedLabel",
        disabled: [2, "disabled", "disabled", booleanAttribute],
        errorStateMatcher: "errorStateMatcher"
      },
      outputs: {
        valueChange: "valueChange",
        openedChange: "openedChange",
        selectionChange: "selectionChange"
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: MatFormFieldControl,
        useExisting: ZvSelect
      }])],
      decls: 10,
      vars: 20,
      consts: () => {
        let i18n_0;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @suppress {msgDescriptions}
           */
          const MSG__APP_NODE_MODULES__ZVOOVE_COMPONENTS_FESM2022_ZVOOVE_COMPONENTS_SELECT_MJS_0 = goog.getMsg(" ({$interpolation} selected) ", {
            "interpolation": "\uFFFD0\uFFFD"
          }, {
            original_code: {
              "interpolation": "{{ $customTriggerDataArray().length }}"
            }
          });
          i18n_0 = MSG__APP_NODE_MODULES__ZVOOVE_COMPONENTS_FESM2022_ZVOOVE_COMPONENTS_SELECT_MJS_0;
        } else {
          i18n_0 = $localize`:@@zvc.xSelectedLabel: (${"\uFFFD0\uFFFD"}:INTERPOLATION: selected) `;
        }
        return [i18n_0, [3, "matTooltip", "matTooltipDisabled"], [3, "valueChange", "selectionChange", "openedChange", "ngModel", "disableOptionCentering", "compareWith", "disabled", "multiple", "errorStateMatcher", "panelClass", "placeholder", "required"], [1, "zv-select__multiple-trigger"], [1, "zv-select__search"], [3, "toggleAll", "formControl", "searching", "showToggleAllCheckbox", "toggleAllCheckboxChecked", "toggleAllCheckboxIndeterminate"], [1, "zv-select__error-container"], [1, "zv-select__empty-option"], [1, "zv-select__option", 3, "value", "zv-select__option--hidden", "disabled"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "zv-select__multiple-trigger__label"], [1, "zv-select__multiple-trigger__selected-label"], [1, "zv-select__error", 3, "disabled"], [1, "zv-select__error-message"], ["mat-icon-button", "", 1, "zv-select__error-reload-btn", 3, "click"], [1, "zv-select__option", 3, "value", "disabled"]];
      },
      template: function ZvSelect_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 1)(1, "mat-select", 2);
          i0.ɵɵlistener("valueChange", function ZvSelect_Template_mat_select_valueChange_1_listener($event) {
            return ctx.onValueChange($event);
          })("selectionChange", function ZvSelect_Template_mat_select_selectionChange_1_listener($event) {
            return ctx.onSelectionChange($event);
          })("openedChange", function ZvSelect_Template_mat_select_openedChange_1_listener($event) {
            return ctx.onOpenedChange($event);
          });
          i0.ɵɵtemplate(2, ZvSelect_Conditional_2_Template, 2, 1, "mat-select-trigger")(3, ZvSelect_Conditional_3_Template, 5, 3, "mat-select-trigger", 3);
          i0.ɵɵelementStart(4, "mat-option", 4)(5, "ngx-mat-select-search", 5);
          i0.ɵɵlistener("toggleAll", function ZvSelect_Template_ngx_mat_select_search_toggleAll_5_listener($event) {
            return ctx.onToggleAll($event);
          });
          i0.ɵɵelementEnd()();
          i0.ɵɵtemplate(6, ZvSelect_Conditional_6_Template, 8, 4, "div", 6)(7, ZvSelect_Conditional_7_Template, 2, 0, "mat-option", 7);
          i0.ɵɵrepeaterCreate(8, ZvSelect_For_9_Template, 3, 6, "mat-option", 8, ctx.trackByOptions, true);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵproperty("matTooltip", ctx.tooltip)("matTooltipDisabled", !ctx.multiple);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngModel", ctx.value)("disableOptionCentering", true)("compareWith", ctx.compareWith)("disabled", ctx.disabled)("multiple", ctx.multiple)("errorStateMatcher", ctx.errorStateMatcher)("panelClass", ctx.panelClass)("placeholder", ctx.placeholder)("required", ctx.required);
          i0.ɵɵadvance();
          i0.ɵɵconditional(!ctx.multiple && ctx.triggerTemplate && !ctx.empty ? 2 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.multiple && !ctx.empty ? 3 : -1);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("formControl", ctx.filterCtrl)("searching", ctx.loading)("showToggleAllCheckbox", ctx.showToggleAll)("toggleAllCheckboxChecked", ctx.toggleAllCheckboxChecked)("toggleAllCheckboxIndeterminate", ctx.toggleAllCheckboxIndeterminate);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.hasError ? 6 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.showEmptyInput ? 7 : -1);
          i0.ɵɵadvance();
          i0.ɵɵrepeater(ctx.items);
        }
      },
      dependencies: [MatIconButton, MatIcon, MatTooltip, MatSelect, ReactiveFormsModule, i3.NgControlStatus, i3.RequiredValidator, i3.FormControlDirective, FormsModule, i3.NgModel, MatSelectTrigger, NgTemplateOutlet, MatOption, NgxMatSelectSearchModule, i4.MatSelectSearchComponent, ZvErrorMessagePipe],
      styles: [".zv-select__option--hidden{display:none!important}.zv-select__error-container{display:flex;align-items:center;gap:1em}.zv-select__error-message{color:var(--zv-components-error)}.zv-select__error-reload-btn{margin:0 .5em 0 auto}ngx-mat-select-search .mat-select-search-clear{line-height:1;width:2.5em;height:2.5em}.zv-select__multiple-trigger{display:flex;gap:.5em}.zv-select__multiple-trigger__label{overflow:hidden;text-overflow:ellipsis}.zv-select__multiple-trigger__selected-label{opacity:.75;font-size:.75em;padding-right:.5em}\n"],
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return ZvSelect;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ZvSelectModule = /*#__PURE__*/(() => {
  class ZvSelectModule {
    /** @deprecated Use provideSelectService */
    static forRoot(selectServiceType) {
      return {
        ngModule: ZvSelectModule,
        providers: [{
          provide: ZvSelectService,
          useClass: selectServiceType
        }]
      };
    }
    static ɵfac = function ZvSelectModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ZvSelectModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ZvSelectModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, FormsModule, ReactiveFormsModule, MatSelectModule, MatTooltipModule, NgxMatSelectSearchModule, ZvSelect]
    });
  }
  return ZvSelectModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function provideSelectService(selectServiceType) {
  return [{
    provide: ZvSelectService,
    useClass: selectServiceType
  }];
}

// export what ./public_api exports so we can import with the lib name like this:
// import { ModuleA } from 'libname'

/**
 * Generated bundle index. Do not edit.
 */

export { DefaultZvSelectDataSource, DefaultZvSelectService, ZvSelect, ZvSelectDataSource, ZvSelectLoadTrigger, ZvSelectModule, ZvSelectOptionTemplate, ZvSelectService, ZvSelectSortBy, ZvSelectTriggerTemplate, isZvSelectDataSource, isZvSelectOptionsData, provideSelectService };
